import React from "react";
import { graphql } from "gatsby";

import Layout from "../../components/Layout";

import WithI18next from "../../components/WithI18next";

import NetlifyContactForm from "../../components/Forms/NetlifyContactForm";
import { getFormName, FORM_TYPES } from "../../hooks/useContactForm";
import ContactUsLayout from "../../layouts/ContactUsLayout";

const ContactUsPage = ({ data, t, lang }) => {
  return (
    <Layout
      title={t("contactUs.seo.title")}
      description={t("contactUs.seo.description")}
    >
      <ContactUsLayout data={data} />

      {lang === "en" && (
        <>
          <NetlifyContactForm formName={getFormName(FORM_TYPES.PARTNERSHIP)} />
          <NetlifyContactForm formName={getFormName(FORM_TYPES.MARKETING)} />
        </>
      )}
    </Layout>
  );
};

export default WithI18next()(ContactUsPage);

export const query = graphql`
  query (
    $wpLocale: String!
    $wpGlobalConfig: String!
    $wpShareGlobalConfig: String
    $isIndo: Boolean = false
  ) {
    ...GetOnBoardContent

    allOfficeLocations: allWpOfficeLocationItem(
      filter: {
        language: { locale: { eq: "en_US" } }
        acfGlobalConfiguration: { gcLinkTo: { eq: ".all" } }
        acfOfficeLocations: { olPrimaryAddress: { ne: $wpGlobalConfig } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          title
          content
          acfOfficeLocations {
            olLocationIcon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
    currentOfficeLocation: allWpOfficeLocationItem(
      filter: {
        language: { locale: { eq: "en_US" } }
        acfGlobalConfiguration: { gcLinkTo: { eq: ".all" } }
        acfOfficeLocations: { olPrimaryAddress: { eq: $wpGlobalConfig } }
      }
      sort: { order: ASC, fields: date }
    ) {
      edges {
        node {
          title
          content
          acfOfficeLocations {
            olLocationIcon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
    afterContactForm: allWpComponentItem(
      filter: {
        acfComponents: { cApplySection: { eq: "after_contact_form" } }
        language: { locale: { eq: $wpLocale } }
        acfGlobalConfiguration: { gcLinkTo: { eq: $wpShareGlobalConfig } }
      }
      sort: { order: ASC, fields: date }
    ) @skip(if: $isIndo) {
      edges {
        node {
          title
          slug
          content
        }
      }
    }
  }
`;
